import { Color, DesignToken, getDesignTokens } from './color';
import type { DesignTokenSet } from './color';

export { Color, DesignToken, getDesignTokens };
export type { DesignTokenSet };
